<template>
  <div>
    <div class="page-container">
      <result :state="state" :desc="desc" :title="title" />
    </div>
  </div>
</template>
<script>
import result from "@/components/base/result";
export default {
  name: "BaseNoData",
  components: {
    result,
  },
  data() {
    return {
      state: "error",
      desc: "",
    };
  },
  computed: {},
  created() {
    console.log(11);
    this.state = "warning";
    this.title = "当前不是钉钉环境，请用手机版钉钉查看";
  },
  methods: {},
};
</script>
<style lang="less" scoped></style>
